import React, { Suspense } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Projects from './components/Projects';
import Work from './components/Work';
import Education from './components/Education';
import SkillBars from './components/SkillBars';
import Resume from './components/Resume';
import Footer from './components/Footer';
import PythonCompiler from './components/PythonCompiler';
import BlogHome from './blog/BlogHome';
import BlogPostLayout from './blog/BlogPostLayout';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

function MainSite() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Box sx={{ marginTop: '64px' }}>
        <Container>
          <main>
            <Work />
            <Projects />
            <Education />
            <Resume />
            <SkillBars />
            <PythonCompiler />
          </main>
        </Container>
        <Footer />
      </Box>
    </div>
  );
}

const BlogGraphView = React.lazy(() => import('./blog/BlogGraphView'));

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainSite />} />
        <Route path="/blog" element={<BlogHome />} />
        <Route path="/blog/:slug" element={<BlogPostLayout />} />
        <Route
          path="/blog/map"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <BlogGraphView />
            </Suspense>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
